export default "__VITE_ASSET__BKqZ1GoY__"